module.exports = __webpack_public_path__ + "img/Sacombank_DKDKSuDungUuDaiGolf-hình ảnh-1.514772de.jpg";